<template lang="pug">
  .chart-showcase
    .mx-12
      h2.acg-heading.d-inline {{title}}
        div(style="visibility:hidden").d-inline
          tooltip-btn(label="Refresh Insights" icon="mdi-refresh" tooltip-color="secondary" large @click="refreshVisuals")
        h2.acg-heading.px-2.d-inline.font-weight-light.text--secondary(
          v-if="description"
        ) {{description}}
        .caption You can click on each chart to make it bigger and adjust filters.
    v-slide-group(:show-arrows="$vuetify.breakpoint.smAndUp")
      v-slide-item(v-for="chart in charts" :key="chart.title")
          DataCard(
            :props = "chart"
            rows="1"
            show-nav
            hover-details
            style="width:450px"
            @click="dialog=true"
          ).ma-1
</template>

<script>
import DataCard from "@/components/Chartcard.vue";
import TooltipBtn from "@/components/TooltipBtn.vue";
import data from '@/visualizations/data';

export default {
  props: ["title", "description"],
  data: () => ({
    charts: [],
    dialog: false
  }),
  components: {
    DataCard,
    TooltipBtn
  },
  mounted() {
    this.refreshVisuals();
  },
  methods: {
    refreshVisuals() {
       this.charts = data.filter(c => {return c.visible === true;}).sort(() => Math.random() - 0.5).slice(0,6);
    }
  },
  computed: {}
};
</script>